export default __webpack_public_path__ + "static/media/deal-15.33d6b98c.webp";